// extracted by mini-css-extract-plugin
module.exports = {"mobile":"primarybutton-module--mobile--sgCMY","button":"primarybutton-module--button--xpNGz","desktop":"primarybutton-module--desktop--4DvaG"};